import { render, staticRenderFns } from "./TonalTest.vue?vue&type=template&id=3c6755ea&scoped=true"
import script from "./TonalTest.vue?vue&type=script&lang=js"
export * from "./TonalTest.vue?vue&type=script&lang=js"
import style0 from "./TonalTest.vue?vue&type=style&index=0&id=3c6755ea&prod&lang=css"
import style1 from "./TonalTest.vue?vue&type=style&index=1&id=3c6755ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6755ea",
  null
  
)

export default component.exports